import { defineCollectionStore } from '@/utils/defineCollectionStore';

export const useSitesStore = defineCollectionStore({
	id: 'sites',
	endpoint: '/api/sites',
	dataKey: 'sites',
	mapKey: 'map',
	dataFallback: [],
	mapFallback: {},
	trackLastFetched: true,
	errorLabel: 'Fetch Sites Error: ',
	fetchName: 'fetchSites',
	archive: {
		toggleName: 'updateSites',
		archivedDataKey: 'archivedSites',
		archivedMapKey: 'archivedMap',
		archivedFetchName: 'fetchArchivedSites',
		archivedEndpoint: (year) => `/api/archive/${year}/sites`,
		getters: {
			sitesData: { role: 'data', fallback: () => [], mode: 'truthy' },
			sitesMap: { role: 'map', fallback: () => ({}), mode: 'truthy' },
		},
	},
	byId: {
		actionName: 'fetchSiteById',
		endpoint: (id) => `/api/sites/${id}`,
	},
});
